import {Component, Input, OnInit} from '@angular/core';
import { PagedResponse } from '@edl-development/edl-common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({ 
    selector: 'expired-cycles',
    templateUrl: './expired-cycles.component.html',
    styleUrls:   ['./expired-cycles.component.scss']
})

export class ModalUserExpiredCycles implements OnInit { 
    @Input() itemCycles: PagedResponse;
    @Input() route: string;
    
    Cycles:any ;
    today: Date;

    constructor(
        public activeModal: NgbActiveModal
    ) {}

    ngOnInit() {
        this.today = new Date();
        this.today.setHours(4, 0, 0, 0);
        this.Cycles = this.itemCycles.Results;

    }
 
    GetExpirationDays(days:number){
        return Math.abs(days);
    }

}

